/* globals process */

import React, { Component } from "react";
import { connect } from "react-redux";
import { history } from "../../_helpers";
import { alertActions } from "../../_actions";
import { userActions } from "../../_actions";
import FontAwesome from "react-fontawesome";
import "./index.css";

class LoginPage extends Component {
  constructor(props) {
    super(props);
    const { dispatch } = this.props;
    history.listen(() => {
      // clear alert on location change
      dispatch(alertActions.clear());
    });

    // reset login status
    this.props.dispatch(userActions.logout());
    this.state = {
      username: "",
      password: "",
      submitted: false
    };
    this.backgroundId = this.getRandomInt(1, 6);
  }

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = e => {
    e.preventDefault();

    this.setState({ submitted: true });
    const { username, password } = this.state;
    const { dispatch } = this.props;
    if (username && password) {
      dispatch(userActions.login(username, password, this.props.location.state));
    }
  };

  getRandomInt = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  renderBackgroundClass = () => {
    return "login-page-bg-" + this.backgroundId;
  };

  render = () => {
    const { username, password, submitted } = this.state;
    return (
      <div className={"login-page " + this.renderBackgroundClass()}>
        <div className={"login-page-overlay"} />
        <div className="loginPage">
          <div className="login-border">
            <div className="login-box">
              <h1>Metro Tunnel Environmental Monitor</h1>
              <form name="form" onSubmit={this.handleSubmit}>
                <div className={"form-group icon-holder" + (submitted && !username ? " has-error" : "")}>
                  <FontAwesome name="user" />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Email"
                    name="username"
                    value={username}
                    onChange={this.handleChange}
                  />
                  {submitted &&
                    !username && (
                      <div className="errorMsgCon">
                        <div className="help-block">
                          <FontAwesome name="exclamation-circle" /> Username is required
                        </div>
                      </div>
                    )}
                </div>
                <div className={"form-group icon-holder" + (submitted && !password ? " has-error" : "")}>
                  <FontAwesome name="key" />
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Password"
                    name="password"
                    value={password}
                    onChange={this.handleChange}
                  />
                  {submitted &&
                    !password && (
                      <div className="errorMsgCon">
                        <div className="help-block">
                          <FontAwesome name="exclamation-circle" /> Password is required
                        </div>
                      </div>
                    )}
                </div>
                <div className="form-group">
                  <button className="btn btn-primary">Login</button>
                  <a className="login-help" href={process.env.REACT_APP_API_HOST + "/password_reset/"} target="_blank">
                    Reset Password
                  </a>
                </div>
              </form>

              <div className="PTALogo" alt="logo" />
            </div>
            <p className="copyright">© Copyright 2018</p>
          </div>
        </div>
      </div>
    );
  };
}

function mapStateToProps(state) {
  const { alert } = state;
  const { user } = state.authentication;
  return {
    alert,
    user
  };
}

export default connect(mapStateToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/_components/LoginPage/index.js